/*eslint-disable*/
import gamePreviewMixin from '../trainer/gamePreviewMixin'

const RULE101_OPERATIONS = ['101', '1001', '10101'];

export default {
    mixins: [gamePreviewMixin],
    data () {
        return {
            digitCapacity: {
                1: this.$i18n.t('common.common_gameSetting_digitCapacity1'),
                2: this.$i18n.t('common.common_gameSetting_digitCapacity2'),
                3: this.$i18n.t('common.common_gameSetting_digitCapacity3'),
                4: this.$i18n.t('common.common_gameSetting_digitCapacity4'),
                5: this.$i18n.t('common.common_gameSetting_digitCapacity5'),
                6: this.$i18n.t('common.common_gameSetting_digitCapacity6'),
                7: this.$i18n.t('common.common_gameSetting_digitCapacity7'),
                8: this.$i18n.t('common.common_gameSetting_digitCapacity8')
            },
            operations: {
                multiply: this.$i18n.t('trainer.trainer_gameFormSetting_multiplication'),
                divide: this.$i18n.t('trainer.trainer_gameFormSetting_division')
            },
            extraOperations: {
                abCrossAc: this.$i18n.t('trainer.trainer_gameFormSetting_rule') + ' AB*AC',
                rule101: this.$i18n.t('trainer.trainer_gameFormSetting_rule') + ' 101',
                mirror: this.$i18n.t('trainer.trainer_gameFormSetting_mirror'),
            },
        }
    },
    methods: {
        field (prop) {
            let fields = []
            for (let key in this.settings[prop]) {
                if (prop === 'extraOperations') {
                    (this.settings[prop][key] === true || this.settings[prop][key].isChosen === true) &&
                    fields.push(this[prop][key]);
                } else {
                    this.settings[prop][key] && fields.push(this[prop][key])

                }
            }
            return fields.join(', ')
        }
    },
    computed: {
        areExtraOperationsEnabled() {
            return this.settings.extraOperations && Object.values(this.settings.extraOperations).find(extraOperation => {
                return extraOperation === true || extraOperation.isChosen === true;
            });
        },
        dividerMultiplier() {
            const isRule101Chosen = this.settings.extraOperations?.rule101.isChosen;
            const rule101ChosenOperation = RULE101_OPERATIONS.find(operation => {
                return this.settings.extraOperations?.rule101[operation];
            });

            return isRule101Chosen
                ? rule101ChosenOperation
                : this.digitCapacity[this.settings.digitCapacity.right.join()];

        },
    },
}
